import { Link } from "react-router";
import { ReactSVG } from "react-svg";

import logo from "../assets/svg/logo.svg";

const Header = () => {
	return (
		<header className="absolute flex w-full max-w-5xl justify-center p-8 md:justify-start">
			<Link to="/" className="z-30 cursor-pointer">
				<ReactSVG src={logo} title="San Zorz" className="[&_svg]:h-auto [&_svg]:w-30 [&_svg]:md:w-40 [&_svg]:lg:w-50" />
			</Link>
		</header>
	);
};

export default Header;
